// extracted by mini-css-extract-plugin
export default {"root":"VoiceUser_root__H-9+6","disabled":"VoiceUser_disabled__uhhhE"};